import { render, staticRenderFns } from "./ModalGenero.vue?vue&type=template&id=2522ab15&scoped=true&"
import script from "./ModalGenero.vue?vue&type=script&lang=js&"
export * from "./ModalGenero.vue?vue&type=script&lang=js&"
import style0 from "./ModalGenero.vue?vue&type=style&index=0&id=2522ab15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2522ab15",
  null
  
)

export default component.exports